import './MyData.scss';

import React from 'react';

import LoadingComponent from '../../components/Loading';
import { useQuery } from '@tanstack/react-query';
import { getMyData } from '../../services/MyData.service';
import { UserForm } from './form';
import { NotFound } from '../NotFound';
import { USER_DATA_QUERY } from '../../utils/queries/userQueries';

function MyData(): JSX.Element {
  const myData = useQuery({
    queryFn: getMyData,
    queryKey: [USER_DATA_QUERY]
  });

  if (myData.data) {
    return <UserForm userData={myData.data} />;
  }

  if (myData.isError) {
    return <NotFound />;
  }

  return (
    <div className="my-data main-content main-content--has-disclaimer">
      <span className="my-data__main-title">Meus Dados</span>
      {myData.isLoading && <LoadingComponent />}
    </div>
  );
}

export default MyData;
